import { Link } from 'react-router-dom'
import { Compass } from '@phosphor-icons/react'
import { EmptyState } from '@/ui'
import { useI18n } from '@/i18n'

export function NotFoundPage() {
  const { t } = useI18n()
  return (
    <main className="flex min-h-dvh items-center justify-center bg-paper px-4">
      <EmptyState
        icon={<Compass />}
        title={t('common.notFound')}
        description={t('common.notFoundBody')}
        action={
          <Link
            to="/"
            className="inline-flex min-h-touch items-center rounded-chip border border-ink bg-ink px-5 font-mono text-[13px] font-bold uppercase tracking-label text-paper"
          >
            {t('common.goHome')}
          </Link>
        }
      />
    </main>
  )
}
